export default "__VITE_ASSET__48a62ed1__"